/**
 * Learn more about deep linking with React Navigation
 * https://reactnavigation.org/docs/deep-linking
 * https://reactnavigation.org/docs/configuring-links
 */

import * as Linking from 'expo-linking';

export default {
  prefixes: [Linking.createURL('/')],
  config: {
    screens: {
        Root: {
            screens: {
              Home: '',
              QuemSomos: 'quemsomos',
              Caravana: 'caravana',
              Conexo: 'conexo',
              Growth: 'programa_growth',
              Capacitacao: 'capacitacao',
              MulherEmpresaria: 'certificacao_mulher_empresaria',
              FaleConosco: 'fale_conosco',
              PerguntasFrequentes: 'perguntas_frequentes',
              FormRD: 'inscricao',
              FormRDMulher: 'inscricao_mulher_empresaria',
              FormRDCaravanaVit: 'inscricao_caravana_vit',
              FormRDCaravanaFeira: 'inscricao_caravana_feira',
              FormRDCaravanaSsa: 'inscricao_caravana_ssa',
              FormRDConexo: 'inscricao_conexo',
              Privacidade: 'politica_privacidade'
          },
        },
      NotFound: '*',
    },
  },
}
